'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = getHomeFilterDependencies;

var _fp = require('lodash/fp');

var _fp2 = _interopRequireDefault(_fp);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function getHomeFilterDependencies(_ref) {
  var home = _ref.item,
      dependencies = _ref.dependencies,
      data = _ref.data;
  var communities = data.communities,
      plans = data.plans,
      areas = data.areas;

  if (!Array.isArray(dependencies)) {
    return {};
  }

  var results = {};

  if (dependencies.includes('community') || dependencies.includes('area')) {
    results.community = _fp2.default.find({ _id: _fp2.default.get('containedIn', home) }, communities);
  }

  if (dependencies.includes('area')) {
    results.area = _fp2.default.find({ name: _fp2.default.get('area', results.community) }, areas);
  }

  if (dependencies.includes('plan')) {
    results.plan = _fp2.default.find({ _id: _fp2.default.get('plan', home) }, plans);
  }

  return results;
}


//////////////////
// WEBPACK FOOTER
// ./~/@bd/bdcore-data/build/Homes/filters/getHomeFilterDependencies.js
// module id = 861
// module chunks = 0